import { Card } from "@/components/ui/card";
import { Calendar } from "@/components/ui/calendar";
import { CalendarDays } from "lucide-react";
import { parseISO, format } from "date-fns";

export default function HistoricalPanel({ dates, selectedDate, onSelect, isLoading }) {
  const dateSet = new Set(dates);

  const modifiers = {
    hasData: (day) => dateSet.has(format(day, "yyyy-MM-dd")),
  };
  const modifiersClassNames = {
    hasData:
      "relative after:content-[''] after:absolute after:bottom-1 after:left-1/2 after:-translate-x-1/2 after:w-1 after:h-1 after:rounded-full after:bg-[#FF3B30]",
  };

  return (
    <div className="space-y-6">
      <Card className="bg-[#121214] border-white/10 rounded-md p-5">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-bold tracking-tight">Historical view</h3>
          <CalendarDays className="h-4 w-4 text-zinc-500" />
        </div>
        <p className="text-xs font-mono text-zinc-500 mt-1">
          Red dot = scan available
        </p>
        <div className="mt-3">
          <Calendar
            data-testid="historical-calendar"
            mode="single"
            selected={selectedDate ? parseISO(selectedDate) : undefined}
            onSelect={(d) => d && onSelect(format(d, "yyyy-MM-dd"))}
            modifiers={modifiers}
            modifiersClassNames={modifiersClassNames}
            disabled={(day) => !dateSet.has(format(day, "yyyy-MM-dd"))}
            className="rounded-md border border-white/10 bg-[#09090B]"
          />
        </div>
      </Card>

      <Card className="bg-[#121214] border-white/10 rounded-md p-5">
        <h3 className="text-sm font-bold tracking-tight mb-3">Recent scans</h3>
        {isLoading && (
          <div className="space-y-2">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="h-8 rounded bg-zinc-800/60 animate-pulse" />
            ))}
          </div>
        )}
        {!isLoading && dates.length === 0 && (
          <p className="text-xs font-mono text-zinc-500">No scans recorded yet.</p>
        )}
        <ul className="space-y-1" data-testid="recent-scans-list">
          {dates.slice(0, 8).map((d) => {
            const active = selectedDate === d;
            return (
              <li key={d}>
                <button
                  data-testid={`history-date-${d}`}
                  onClick={() => onSelect(d)}
                  className={`w-full text-left px-3 py-2 rounded font-mono text-xs flex items-center justify-between hover:bg-zinc-800/70 ${
                    active ? "bg-zinc-800/90 text-zinc-50" : "text-zinc-300"
                  }`}
                >
                  <span>{d}</span>
                  <span className="text-[10px] text-zinc-500 uppercase tracking-widest">
                    view
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      </Card>
    </div>
  );
}
